import { render, staticRenderFns } from "./detailNav.vue?vue&type=template&id=5730d2c4&scoped=true"
import script from "./detailNav.vue?vue&type=script&lang=js"
export * from "./detailNav.vue?vue&type=script&lang=js"
import style0 from "./detailNav.vue?vue&type=style&index=0&id=5730d2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5730d2c4",
  null
  
)

export default component.exports